import { render, staticRenderFns } from "./clientsBands.vue?vue&type=template&id=61aced66&scoped=true"
import script from "./clientsBands.vue?vue&type=script&lang=js"
export * from "./clientsBands.vue?vue&type=script&lang=js"
import style0 from "./clientsBands.vue?vue&type=style&index=0&id=61aced66&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aced66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61aced66')) {
      api.createRecord('61aced66', component.options)
    } else {
      api.reload('61aced66', component.options)
    }
    module.hot.accept("./clientsBands.vue?vue&type=template&id=61aced66&scoped=true", function () {
      api.rerender('61aced66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LabelGroup/clientsBands.vue"
export default component.exports